import { Documento } from '../services/documentoService';

/** Associado = data_valido_ate vigente (mesma regra do backend). */
export const ehAssociado = (dataValidoAte?: string | null): boolean => {
  if (!dataValidoAte) return false;
  const raw = dataValidoAte.includes('T') ? dataValidoAte : `${dataValidoAte}T12:00:00`;
  const ate = new Date(raw);
  if (Number.isNaN(ate.getTime())) return false;
  const hoje = new Date();
  hoje.setHours(0, 0, 0, 0);
  ate.setHours(0, 0, 0, 0);
  return ate >= hoje;
};

/** Visitante: só o primeiro documento cadastrado de cada tipo. */
export const documentosVisiveisParaSocio = (
  dataValidoAte: string | undefined | null,
  documentos: Documento[],
): Documento[] => {
  if (ehAssociado(dataValidoAte)) return documentos;

  const porTipo = new Map<string, Documento>();
  for (const doc of documentos) {
    const tipo = doc.tipo_documento;
    const atual = porTipo.get(tipo);
    if (!atual) {
      porTipo.set(tipo, doc);
      continue;
    }
    const uploadDoc = doc.data_upload ? new Date(doc.data_upload).getTime() : Number.MAX_SAFE_INTEGER;
    const uploadAtual = atual.data_upload ? new Date(atual.data_upload).getTime() : Number.MAX_SAFE_INTEGER;
    const idDoc = doc.id ?? Number.MAX_SAFE_INTEGER;
    const idAtual = atual.id ?? Number.MAX_SAFE_INTEGER;
    if (uploadDoc < uploadAtual || (uploadDoc === uploadAtual && idDoc < idAtual)) {
      porTipo.set(tipo, doc);
    }
  }
  return Array.from(porTipo.values());
};
